{
	"allProjects": "All Projects",
	"ariaCreateNewProject": "Create New Project",
	"ariaCreateNewProjectFromEmptyState": "Create New Project From Empty State",
	"ariaCreateNewProjectFromProjectCard": "Create New Project From Project Card",
	"ariaProjects": "projects",
	"ariaProjectsList": "Projects List",
	"ariaSearch": "Search",
	"ariaSortProjectsNewestFirst": "Sort Projects Newest First",
	"ariaSortProjectsOldestFirst": "Sort Projects Oldest First",
	"ariaSwitchProjectsToGridView": "Switch Projects To Grid View",
	"ariaSwitchProjectsToListView": "Switch Projects To List View",
	"createNewProject": "Create new project",
	"date": "Date",
	"name": "Name",
	"newProject": "New Project",
	"noProjectMatchesSearch": "No project matches your search",
	"noProjects": "You do not have any projects",
	"photoCount": "Photo Count",
	"placeholderSearchProjects": "Search projects",
	"projects": "Projects",
	"projectsLinkedToFolders": "Projects are linked to folders on your hard drive."
}
